import { render, staticRenderFns } from "./PharmacyMngt.vue?vue&type=template&id=0ce8b8bc"
import script from "./PharmacyMngt.vue?vue&type=script&lang=js"
export * from "./PharmacyMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports